declare var swal: any;
import { Component, ViewEncapsulation, Input, ChangeDetectionStrategy, OnInit, ViewChild, ElementRef, Renderer2 } from '@angular/core';
import { NgbModal, ModalDismissReasons, NgbActiveModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
//import { FileUploader } from 'ng2-file-upload/ng2-file-upload';
import { ApiResponseModel } from '../../../../../../models/api_response_model';
import { ApiRequestModel } from '../../../../../../models/api_request_model';
import { SpinnerService } from '../../../../../../services/spinner.service';
import { AppData } from '../../../../../../models/appdata';
import { NgForm } from '@angular/forms';
import { Router, ActivatedRoute } from '@angular/router';

//import { DBOperation } from '../../../../../enums/enum';
import { ActorEmploymentPreferencesRequest, ActorContactInfoRequest, EmergencyContactInfoRequest, SaveEmergencyContactInfoRequest } from '../../../../../../models/profileinfo/profileinfo.model';
import { HCPService } from '../../../../../../services/hcp.service';


import * as alertFunctions from '../../../../../../../shared/data/sweet-alerts';
import { NGXToastrService } from '../../../../../../../shared/services/toastr.service';
import { ServiceConsultantMapController, ServiceDetailsByCodeController, ServiceDetailsByCodeRequest, ServiceBranchMapByServiceCodeController, ServiceBranchMapByServiceCodeRequest, ActorImageRequest } from '../../../../../../models/actor/actor';
import { ServiceConsultantMapRequest } from '../../../../../../models/actor/actor';
import { ActorService } from '../../../../../../services/actor.service';
import { CustomCodeTypeRequest_, CustomCodeValuesController_ } from '../../../../../../models/master/mastermodel';
import { FDService } from '../../../../../../services/fd.service';
import { ConsultantMapPipe } from '../../../../../../pipes/actors/actorIdentity.pipes';
import { parse } from 'querystring';
import { Subject, Observable } from 'rxjs';
import { WebcamInitError, WebcamImage, WebcamUtil } from 'ngx-webcam';
import { DOCService } from '../../../../../../services/doc.service';

@Component({
  selector: 'ngbcameraupload',
    templateUrl: './cameraupload.modal.html',
    styleUrls: ['./cameraupload.modal.scss']
})

export class NgbCameraUploadModal implements OnInit {
  @ViewChild('f') IdentitiesForm: NgForm;
    @Input() ActorCode: number;
    @Input() Photo: number;
  @Input() IsShowDetail: boolean = false;
  //@Input() CurrentActorAddEmergencyInfoRequest: EmergencyContactInfoRequest;
  @Input() ServiceCode: number;
  searchTitle: string;
    public ApiResData: ApiResponseModel;
    FileExtension: string = "";
    public Url: string;
  public isRequesting: boolean = false;
  public ShowService: boolean = true;
  //public IsSelected: boolean;
    CurrentActorAddEmergencyInfoRequest: SaveEmergencyContactInfoRequest;
    CurrentActorImageRequest: ActorImageRequest;
    @ViewChild("video") videoElement: ElementRef;
    @ViewChild("canvas") canvas: ElementRef;

    videoWidth = 0;
    videoHeight = 0;
    constraints = {
        video: {
            facingMode: "environment",
            width: { ideal: 225 },
            height: { ideal: 225 }
        }
    };
    constraints2 = {
        video: {
            facingMode: "",
            width: { ideal: 4096 },
            height: { ideal: 2160 }
        }
    };
    public Images: Array<any>;
  constructor(public activeModal: NgbActiveModal, private loaderService: SpinnerService,
    private actorservice: ActorService, private fdservice: FDService, private filter: ConsultantMapPipe,
    private router: Router, private route: ActivatedRoute, private hcpservice: HCPService,
      private tosterservice: NGXToastrService, private renderer: Renderer2, private docservice: DOCService) { }
  ngOnInit() {
    this.CurrentActorAddEmergencyInfoRequest = new SaveEmergencyContactInfoRequest();
    this.CurrentActorAddEmergencyInfoRequest.ConditionalOperator = 10;
    this.CurrentActorAddEmergencyInfoRequest.ActorCode = this.ActorCode;
    this.CurrentActorAddEmergencyInfoRequest.EmergencyContactCode = 0;
    this.CurrentActorAddEmergencyInfoRequest.SendApiRequestModel = AppData.Instance().ApiRequestParms;
    this.ShowService = false;

      this.startCamera();
      this.CurrentActorImageRequest = new ActorImageRequest();
      this.CurrentActorImageRequest.ActorCode = this.ActorCode;
      this.CurrentActorImageRequest.ActorImageCode = this.Photo;
      this.CurrentActorImageRequest.SendApiRequestModel = AppData.Instance().ApiRequestParms;
    this.LoadRegistries();
     

  }
  
  startCamera() {
    //this.CameraCaution();
        if (!!(navigator.mediaDevices && navigator.mediaDevices.getUserMedia)) {
            navigator.mediaDevices.getUserMedia(this.constraints).then(this.attachVideo.bind(this)).catch(this.handleError);
        } else {
            //alert('Sorry, camera not available.');
          this.CameraCaution();
        }
    }

    attachVideo(stream) {
        this.renderer.setProperty(this.videoElement.nativeElement, 'srcObject', stream);
        this.renderer.listen(this.videoElement.nativeElement, 'play', (event) => {
            this.videoHeight = this.videoElement.nativeElement.videoHeight;
            this.videoWidth = this.videoElement.nativeElement.videoWidth;
            //this.videoElement.nativeElement.src = window.URL.revokeObjectURL(stream);

            //this.videoElement.nativeElement.srcObject = stream;
        });
    }

    capture() {
        //this.renderer.setProperty(this.canvas.nativeElement, 'width', this.videoWidth);
        //this.renderer.setProperty(this.canvas.nativeElement, 'height', this.videoHeight);
        this.canvas.nativeElement.getContext('2d').drawImage(this.videoElement.nativeElement, 0, 0,225,225);
        // alert(this.videoElement.nativeElement.srcObject);
        //this.Images.push(this.videoElement.nativeElement.srcObject);
        //this.Images.push(this.canvas.nativeElement.toDataURL("image/png"));
        this.Url = this.canvas.nativeElement.toDataURL("image/png");
      
        
        //alert(this.Url);
        //this.Images.push(this.canvas.nativeElement.toDataURL("image/png"))
    }

    handleError(error) {
        console.log('Error: ', error);
    }


  LoadRegistries() {
    this.StartRefreshing();



    //this.GetBranchMap();


  }

    OnSubmit() {
        (this.canvas.nativeElement as HTMLCanvasElement).toBlob((blob) => {
            let formData: FormData = new FormData();
            formData.append('userpic', blob, this.ActorCode.toString() + "_Photo");
            this.FileExtension = ".png";//blob.name.substring(this.file.name.lastIndexOf("."));
            this.CurrentActorImageRequest.FileExtension = this.FileExtension;

            this.docservice.xUploadActorImage(formData, this.CurrentActorImageRequest)
                .subscribe(data => {
                    // console.log('data------------------------------------>' + data)
                    let a: number = data
                    //// console.log('a------------------------------------>' + a)

                    // alertFunctions.AlertParam('Upload Successfully...');
                    this.tosterservice.ToasterSuccessAlertParam('Uploaded Successfully.....!');
                  this.offCamera();
                    //  this.router.navigate(['nurse/profile']);
                    
                    
                    this.stopRefreshing();






                },
                    (error) => {

                        if (error == "401 - Unauthorized") {
                            alertFunctions.AlertParamEr(error);
                            this.stopRefreshing();



                        }
                        else {
                            alertFunctions.AlertParamEr(error);
                            this.stopRefreshing();
                        }
                    }
                );
        })
    }

  offCamera() {
    this.activeModal.close();
        const stream = this.videoElement.nativeElement.srcObject;
        const tracks = stream.getTracks();

        tracks.forEach(function (track) {
            track.stop();
        });

        this.videoElement.nativeElement.srcObject = null;
        //alert("offcamera");
       
    }
    


    
    

  onSubmit() {

    this.StartRefreshing();
    //alert(this.CurrentActorEmploymentPreferencesRequest.ReasonForAccommodation);
    this.CurrentActorAddEmergencyInfoRequest.AddressLine1 = "";
    this.CurrentActorAddEmergencyInfoRequest.AddressLine2 = "";
    this.hcpservice.SaveEmergencyContactInfo(this.CurrentActorAddEmergencyInfoRequest)
      .subscribe((result) => {
        this.ApiResData = result;
        if (!this.ApiResData.hasError) {

          if (this.ApiResData.Result > 0) {
            this.ShowService = false;
            //alertFunctions.AlertParam('Saved Successfully.....!');
            this.tosterservice.ToasterSuccessAlertParam('Saved Successfully.....!');

            this.activeModal.close();

            this.stopRefreshing();
          }
          else {
            alertFunctions.AlertParam("Invalid Operation...!");
            this.activeModal.close();

            this.stopRefreshing();

          }

        }
        else {
          this.stopRefreshing();
          if (this.ApiResData.ErrorData != "") {

            alertFunctions.AlertParamEr(this.ApiResData.ErrorData);
            this.activeModal.close();


          }
          else {
            alertFunctions.ShowMessage('Internal Issues', 'Transaction Failed Due to Internal Error.... Please Contact Admin..', 'error');
            this.activeModal.close();
          }
        }

      },


        (error) => {

          if (error == "401 - Unauthorized") {
            alertFunctions.AlertParamEr(error);
            this.activeModal.close();
            this.stopRefreshing();



          }
          else {
            alertFunctions.AlertParamEr(error);
            this.activeModal.close();
            this.stopRefreshing();
          }
        }
      );

  }




  private stopRefreshing() {
    this.loaderService.displayLoader(false);
    this.isRequesting = false;
  }
  private StartRefreshing() {
    this.loaderService.displayLoader(true);
    this.isRequesting = true;
  }
  CameraCaution() {
    swal({
      title: '',
      text: "Please Allow Access for camera!",
      type: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#0CC27E',
      cancelButtonColor: '#FF586B',
      confirmButtonText: 'Allow',
      cancelButtonText: 'Cancel',
      confirmButtonClass: 'btn btn-success btn-raised mr-5',
      cancelButtonClass: 'btn btn-danger btn-raised',
      buttonsStyling: false
    }).then(() => {



      //this.DeleteActorIdentities(FollicularGrowthDetailCode);
      // alertFunctions.AlertParam('Delete Successfully...!');

    }, function (dismiss) {
      // dismiss can be 'overlay', 'cancel', 'close', 'esc', 'timer'
      //if (dismiss === 'cancel') {
      //  swal(
      //    'Cancelled',
      //    'Delete Operation Cancelled :)',
      //    'error'
      //  )
      //}
    })
  }




}
